import { createContext, useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import io from "socket.io-client";
import { BASE_URL } from "./constants";

const SocketContext = createContext();

export const useSocketContext = () => {
  return useContext(SocketContext);
};

export const SocketContextProvider = ({ children }) => {
  const [socketDetails, setSocketDetails] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const { userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    const socket = io(BASE_URL, {
      transports: ["websocket"],
    });
    // console.log("Inside client socket useEffect:", socket.id);

    socket.on("connect", () => {
      console.log("✅ Connected to socket server:", socket.id);
      socket.emit("join_public_room", userInfo?.openedOutletGroup);
    });
    setSocketDetails(socket);
  }, [userInfo?.openedOutletGroup]);

  return (
    <SocketContext.Provider value={{ socketDetails, onlineUsers }}>
      {children}
    </SocketContext.Provider>
  );
};
